export class ApiData {
	pages: [];
	pagesTitle: string;
	objectType:string;
}
